import type { SVGProps } from 'react'

export function TwemojiFlagIreland(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 36 36" {...props}>
      {/* Icon from Twitter Emoji by Twitter - https://creativecommons.org/licenses/by/4.0/ */}
      <path fill="#169B62" d="M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5z" />
      <path fill="#EEE" d="M12 5h12v26H12z" />
      <path fill="#FF883E" d="M32 5h-8v26h8a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4" />
    </svg>
  )
}
